module.exports = __webpack_public_path__ + "img/cloud.e946c7fc.png";